import {
  ANALYTICS_PAGE_LOAD_EVENT_NAME,
  ANALYTICS_CLICK_EVENT_NAME,
  defaultAnalyticsProperties,
} from './analyticsProperties';
import { PageLoadAnalyticsInterface } from '../../interfaces/AnalyticsProperties.interface';
import {
  ORIGIN_SESSION_STORAGE_KEY,
  SESSION_ID_SESSION_STORAGE_KEY,
  SITE_CODE_SESSION_STORAGE_KEY,
} from '../constants/sessionStorageConstants';
import { getParamValue, getClientIdParamValue } from '../helpers';
import { store } from '../../store/store';

export const capturePageLoadAnalytics = (
  payload: PageLoadAnalyticsInterface,
): void => {
  //The if condition will be executed only in case of errors to update the MessageType
  const appError = store.getState().appState.errors;
  if (Object.keys(appError).length > 0) {
    const [key] = Object.keys(appError);
    const error: any = appError[key as keyof object];
    if (error.status) {
      payload = {
        ...payload,
        ExternalCampaignTracking:
          sessionStorage.getItem(SITE_CODE_SESSION_STORAGE_KEY) || '',
        MessageType: `${error.status}:Failed in ${key}` || '',
      };
    }
  }
  const sessionPayload = {
    Token: getParamValue(SESSION_ID_SESSION_STORAGE_KEY),
    ClientId: getClientIdParamValue(),
    OrgChannel: `sca-web:${getParamValue(ORIGIN_SESSION_STORAGE_KEY)}`,
  };
  window._SFDDL = window._SFDDL || {};
  window._SFDDL.pageInfo = {
    ...defaultAnalyticsProperties,
    ...payload,
    ...sessionPayload,
    ExternalCampaignTracking:
      sessionStorage.getItem(SITE_CODE_SESSION_STORAGE_KEY) || '',
  };
  try {
    const event = new CustomEvent(ANALYTICS_PAGE_LOAD_EVENT_NAME);
    window.dispatchEvent(event);
  } catch (error) {
    console.log('Error in dispatching analytics', error);
  }
};

export const captureClickAnalyticsObject = (payload: {
  dataReason: string;
  dataType: string;
  dataObject: string;
  dataChannel?: string;
  responseCode?: string;
  responseDesc?: string;
  dataFieldName?: string;
  dataClassName?: string;
}) => {
  let dataChannel = '';
  if (payload.responseCode && payload.responseDesc) {
    dataChannel = `${payload.responseCode}:${payload.responseDesc}`;
  }
  window._SFDDL = window._SFDDL || {};
  if (payload.dataFieldName) {
    window._SFDDL.click = {
      'field-name': payload.dataFieldName,
      class: payload.dataClassName,
    } as any;
  }
  if (!payload.dataChannel && dataChannel === '') {
    window._SFDDL.click = {
      'data-type': payload.dataType,
      'data-reason': payload.dataReason,
      'data-object': payload.dataObject,
    };
  } else {
    window._SFDDL.click = {
      'data-type': payload.dataType,
      'data-reason': payload.dataReason,
      'data-object': payload.dataObject,
      'data-channel': payload.dataChannel ? payload.dataChannel : dataChannel,
    };
  }
  try {
    const event = new CustomEvent(ANALYTICS_CLICK_EVENT_NAME);
    window.dispatchEvent(event);
  } catch (error) {
    console.log('Error in dispatching analytics', error);
  }
};

export const captureAnalyticsDataAttributes = (event: any) => {
  const dataReason = event.currentTarget.getAttribute('data-reason') ?? '';
  const dataType = event.currentTarget.getAttribute('data-type') ?? '';
  const dataObject = event.currentTarget.getAttribute('data-object') ?? '';
  const dataChannel = event.currentTarget.getAttribute('data-channel') ?? '';
  captureClickAnalyticsObject({
    dataReason,
    dataType,
    dataObject,
    dataChannel,
  });
};
